import { KB_BALANCE } from "../../actions/type";

export default function balance(state = [], action) {
    switch (action.type) {
        case KB_BALANCE:
            return action.payload;;
        default:
            return state
    }
}